<template>
  <div id="loading-bar">
    <div class="loader-wrapper">
      <div class="loader-icon" :style="`background-image:url(${this.$assets.image['loading.png']})`" />
    </div>
  </div>
</template>

<style scoped>
#loading-bar {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader-wrapper {
  text-align: center;
  position: relative;
  width: 12.57em;
  height: 12em;
}
.loader-icon {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  animation: loadersprite 0.9s steps(4) infinite;
}

@keyframes loadersprite {
  100% {
    background-position: -50.28em;
  }
}
</style>
